/**
 * Adzuki.TextareaAutoheight
 */

(function TextareaAutoheight($, Adzuki)
{
	"use strict";

	var autoheight = function autoheight($els)
	{
		// makes sure the required css is applied
		$els.addClass('autoheight');

		$els.on('input', function autosize() {
			var $self = $(this);
			$self.height(0).height(this.scrollHeight - $self.data('autoheight-diff'));
		});

		// $els.on('input', Adzuki.Debounce(function autosize() {
		// 	var $self = $(this);
		// 	$self.height(0).height(this.scrollHeight - $self.data('autoheight-diff'));
		// }, 100));

		// only need to calculate this once per textarea
		$.each($els, function init() {
			var $self = $(this),
				diff  = parseInt($self.css('paddingBottom'))
						+ parseInt($self.css('paddingTop'))
						+ parseInt($self.css('borderTopWidth'))
						+ parseInt($self.css('borderBottomWidth')) || 0;

			$self.data('autoheight-diff', diff);

			// override max-height if desired
			if ($self.data('max-height')) {
				$self.css('max-height', $self.data('max-height')+'px');
			}

			// if pre-filled, resize immediately
			if ($self.val()) {
				$self.trigger('input');
			}
		});
	};

	Adzuki.TextareaAutoheight = autoheight;
}(jQuery, window.Adzuki || {}));
